<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout
            :meun="meunItem"
            :title="meunTitle"
            :title2="meunTitle2"
          ></headerLayout>
        </el-header>
        <el-main class="main" v-loading="tableLoading">
          <div class="mainbody">
            <h3 class="title">提交资料</h3>
            <div class="aLine"></div>
            <div class="infobody">
              <p class="name">{{ info.name }}</p>
              <div class="info_div">
                <span>手机号：</span>
                <span>{{ info.mobile }}</span>
              </div>
              <div class="info_div">
                <span>性别：</span>
                <span>{{ info.gender }}</span>
              </div>
              <div class="info_div">
                <span>身份证号码：</span>
                <span>{{ info.id_card_number }}</span>
              </div>
              <div style="clear: both"></div>
            </div>
            <div class="toPayAlert">
              <div class="el-icon-info" style="color: #1890ff"></div>
              <div class="alertText">
                是否需要缴纳入会费<span class="payMoney">200元</span>
              </div>
              <div class="alertRadio" v-if="result == '拒绝'">
                <el-radio disabled v-model="reject">需缴纳</el-radio>
                <el-radio disabled v-model="reject">无需缴纳</el-radio>
              </div>
              <div class="alertRadio" v-else>
                <div v-if="info.is_pay">
                  <div v-if="info.is_pay == 'Y'">
                    <el-radio v-model="radio" label="Y">需缴纳</el-radio>
                    <el-radio disabled v-model="radio" label="N"
                      >无需缴纳</el-radio
                    >
                  </div>
                  <div v-if="info.is_pay == 'N'">
                    <el-radio disabled v-model="radio" label="Y"
                      >需缴纳</el-radio
                    >
                    <el-radio v-model="radio" label="N">无需缴纳</el-radio>
                  </div>
                </div>
                <div v-else>
                  <el-radio v-model="radio" label="Y">需缴纳</el-radio>
                  <el-radio v-model="radio" label="N">无需缴纳</el-radio>
                </div>
              </div>
            </div>
            <div v-show="info.ais_list">
              <h3 class="title">相关校友</h3>
              <div class="aLine"></div>
              <div class="tableInfo">
                <el-table :data="info.ais_list">
                  <el-table-column
                    prop="uid"
                    label="UID"
                    min-width="1"
                  ></el-table-column>
                  <el-table-column
                    prop="name_cn"
                    label="中文姓名"
                    min-width="1"
                  ></el-table-column>
                  <el-table-column label="性别" min-width="1">
                    <template slot-scope="scope">
                      <span>{{ gender[scope.row.gender] }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="id_card_number"
                    label="身份证号码"
                    min-width="2"
                  ></el-table-column>
                  <el-table-column
                    prop="mobile_phone"
                    label="手机号"
                    min-width="2"
                  ></el-table-column>
                  <el-table-column
                    prop="wechat"
                    label="微信号"
                    min-width="2"
                  ></el-table-column>
                  <el-table-column
                    prop="operating"
                    label="操作"
                    min-width="2"
                    align="left"
                  >
                    <template slot-scope="scope">
                      <el-button
                        class="operateText"
                        size="mini"
                        type="text"
                        @click="toDetails(scope.row)"
                        >详情</el-button
                      >
                      <el-button
                        class="operateText"
                        size="mini"
                        type="text"
                        @click="toPass(scope.row)"
                        >通过并与该校友绑定</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <div class="footSubmit" v-if="info.is_examine == 'Y'">
            <el-button
              style="float: right; margin-right: 30px"
              size="small"
              type="primary"
              @click="toSearch()"
              >通过并绑定其他校友</el-button
            >
            <el-button
              style="float: right; margin-right: 15px"
              size="small"
              @click="toRefuse()"
              >拒绝</el-button
            >
          </div>
        </el-main>
        <image-dialog ref="_imageDialog"></image-dialog>
        <authentication-register-search-dialog
          :radio="radio"
          ref="_searchDialog"
        ></authentication-register-search-dialog>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import * as Utils from "@/utils/utils.js";
import * as StrUtils from "@/utils/strUtils.js";
import * as CApi from "@/api/constant_api.js";
import * as Api from "@/api/api.js";
import { formar_gender } from "@/utils/constant.js";
import { URL_PATH } from "@/config/config";
import leftMeun from "@/components/layout/leftMeun";
import headRight from "@/components/layout/headRight";
import headerLayout from "@/components/layout/headerLayout";
import imageDialog from "@/components/dialog/imageDialog";
import authenticationRegisterSearchDialog from "@/components/dialog/authenticationRegisterSearchDialog";

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
    imageDialog,
    authenticationRegisterSearchDialog,
  },
  data() {
    return {
      tableLoading: false,
      urlPath: URL_PATH,
      meunItem: null,
      meunTitle: "",
      meunTitle2: "注册校友审核认证",
      info: { year: {} },
      data_list: [],
      radio: "",
      reject: "",
      result: "",
      gender: formar_gender,
    };
  },

  methods: {
    initData(meunItem) {
      this.meunItem = meunItem;
      this.meunTitle = this.meunItem.name;
      this.result = this.$route.query.result;
      this.getInfo();
    },
    getInfo: function () {
      this.tableLoading = true;
      this.$api
        .registeredMember({
          token: localStorage.getItem("token"),
          id: this.$route.query.id,
        })
        .then(({ data }) => {
          this.info = data.Data;
          this.info.mobile = this.reValue(this.info.mobile);
          if (this.info.is_pay) {
            this.radio = this.info.is_pay;
          }
          this.info.rejectAfter = this.rejectAfter;
          this.tableLoading = false;
        })
        .catch(({ error }) => {
          this.tableLoading = false;
        });
    },
    // 查看校友详情
    toDetails(row) {
      Api.verifyApi(CApi.api_getAisInfoById, (verify) => {
        if (verify) {
          this.meunItem.userid = row.id;
          localStorage.setItem("meunItem", JSON.stringify(this.meunItem));
          this.$router.push("/data/user-details");
        }
      });
    },
    // 通过
    toPass(row) {
      if (!this.radio) {
        this.$message.error("请选择是否需要缴纳入会费!");
      } else {
        var params = {
          token: localStorage.getItem("token"),
          id: this.info.id,
          is_pass: "Y",
          ais_info_id: row.id,
          is_pay: this.radio,
        };
        console.log(params);
        // if (row) {
        //   params.ais_info_id = row.id;
        // }
        this.$api
          .execRegisteredMember(params)
          .then(({ data }) => {
            this.$router.go(0);
          })
          .catch(({ error }) => {});
      }
    },
    // 去搜索校友
    toSearch() {
      this.$nextTick(() => {
        var url = this.$refs._searchDialog.show(this.info.id);
      });
    },
    // 拒绝
    toRefuse() {
      this.$prompt("请输入拒绝原因", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /\S/,
        inputErrorMessage: "请输入拒绝原因",
      })
        .then(({ value }) => {
          var params = {
            token: localStorage.getItem("token"),
            id: this.info.id,
            is_pass: "N",
            remark: value,
          };
          console.log(params);
          this.$api
            .execRegisteredMember(params)
            .then(({ data }) => {
              this.$router.go(0);
            })
            .catch(({ error }) => {});
        })
        .catch(() => {});
    },
    // 显示图片
    showImage(img_link) {
      this.$nextTick(() => {
        this.$refs._imageDialog.show(img_link);
      });
    },
    getEducation_() {
      let str = "";
      if (this.info.education_nation)
        str = str + this.info.education_nation + " ";
      if (this.info.education_province)
        str = str + this.info.education_province + " ";
      if (this.info.education_city) str = str + this.info.education_city;
      return str;
    },
    getOrganization_() {
      let str = "";
      if (this.info.organization_nation)
        str = str + this.info.organization_nation + " ";
      if (this.info.organization_province)
        str = str + this.info.organization_province + " ";
      if (this.info.organization_city) str = str + this.info.organization_city;
      return str;
    },
    // 显示字段
    reValue(value) {
      return StrUtils.isEmpty(value) ? "未填写" : value;
    },
  },
};
</script>

<style lang="less" scoped>
.mainbody {
  // overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.infobody {
  margin: 32px;
}
.infobody .name {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 18px;
}
.infobody .info_div {
  width: 350px;
  float: left;
  margin-bottom: 8px;
}
.infobody .info_div span {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #595959;
}
.mainbody .boxInfo {
  margin-top: 24px;
  border: 1px solid #e9e9e9;
  box-sizing: border-box;
}
.mainbody .boxInfo .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  padding: 11px 24px;
  background: #fafafa;
  // border: 1px solid #e9e9e9;
  box-sizing: border-box;
}
.mainbody .boxInfo .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.boxInfo .experience {
  padding: 16px 24px;
}
.boxInfo .experience .title1 {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #595959;
  margin-bottom: 12px;
}
.experience .info_div {
  width: 280px;
  float: left;
  margin-bottom: 8px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-left: 32px;
  margin-right: 32px;
}
.toPayAlert {
  width: 40vw;
  height: 40px;
  font-family: "PingFang SC";
  font-style: normal;
  background: #e6f7ff;
  border: 1px solid #bae7ff;
  margin: 33px 32px 238px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  position: relative;
  // line-height: 40px;
}
.toPayAlert .alertText {
  font-weight: 400;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  margin-left: 8px;
}
.toPayAlert .alertText .payMoney {
  color: #fa5151;
  font-weight: 600;
  font-size: 14px;
  margin-left: 12px;
}
.toPayAlert .alertRadio {
  font-weight: 400;
  font-size: 14px;
  color: #606266;
  position: absolute;
  right: 16px;
}
</style>


// WEBPACK FOOTER //
// src/pages/wxapp/authenticationRegisterDetails.vue